<template>
  <b-form-group class="passwordInputGroup">
    <SInput
      v-model="password"
      class="mb-2"
      validation-rules="required"
      validation-field-name="password"
      size="lg"
      :type="showPassword ? 'text' : 'password'"
      data-cy="settings-form-password-new"
      autocomplete="off"
      placeholder-ignored-by-sr
      :placeholder="hideInputPlaceholder ? '' : $t('login.login_sign_in.input_password.placeholder')"
      :label-text="customLabelFirstPassword || $t('login.login_sign_in.input_password.placeholder')"
    >
      <template #right-action>
        <!-- button that triggers showPassword -->
        <b-button
          v-if="password"
          variant="transparent"
          class="show-hide-password reset-button"
          :aria-pressed="showPassword ? 'true' : 'false'"
          @click="showPassword = !showPassword"
        >
          <sdui-icon class="fz-small" :class="!showPassword ? 'icon-eye' : 'icon-hide-o'" />
          <span class="sr-only">{{
            !showPassword ? $t('login.login_sign_in.input_password.show_password') : $t('login.login_sign_in.input_password.hide_password')
          }}</span>
        </b-button>
      </template>
    </SInput>

    <SInput
      v-model="secondPassword"
      :validation-rules="{ required: true, is: password, min: 12 }"
      validation-field-name="secondPassword"
      validation-field-label="password"
      size="lg"
      type="password"
      data-cy="settings-form-password-check"
      :placeholder="hideInputPlaceholder ? '' : $t('register.password.placeholderPasswordConfirmation')"
      :label-text="$t('register.password.placeholderPasswordConfirmation')"
      autocomplete="off"
      autofill="off"
      class="mb-2"
      :invalid-text="secondPassword && password !== secondPassword ? $t('register.password.validation.dont_match') : ''"
    />

    <div class="container">
      <SProgress
        v-if="password.length > 0"
        v-model="state"
        :label="$t('global.password_safety')"
        class="mb-2 mt-4"
        :variant="state >= 30 ? (state >= 95 ? 'success' : 'warning') : 'danger'"
      />

      <div v-if="password.length || secondPassword.length">
        <!-- Required amount -->
        <small v-if="password.length < required"
               class="text-muted"
        >{{ $t('register.password.validation.length_start') }} {{ required - password.length }}
          {{ $t('register.password.validation.length_end') }}
        </small>

        <!-- Fits the required amount: -->
        <small v-if="password.length >= required && password.length <= optimal"
               class="text-warning-dark"
        >{{ $t('register.password.validation.success_2') }} <sdui-icon class="icon-check-o text-warning-dark" />
        </small>

        <!-- Secure enough -->
        <small v-else-if="password.length >= optimal && password.length > required"
               class="text-success-dark"
        >{{ $t('register.password.validation.success') }} <sdui-icon class="icon-check-o text-success-dark" />
        </small>
      </div>
    </div>
  </b-form-group>
</template>

<script>
import SProgress from 'src/components/base/SProgress.vue'

export default {
  // TODO VUE3: Remove compatConfig when @vue/compat is removed
  compatConfig: {
    COMPONENT_V_MODEL: false,
  },

  name: 'InputPasswordIndicator',
  components: { SProgress },
  props: {
    modelValue: {
      type: String,
      default: ''
    },

    hideInputPlaceholder: {
      type: Boolean,
      default: false
    },

    customLabelFirstPassword: {
      type: String,
      default: '',
    }
  },

  data: () => ({
    password: '',
    secondPassword: '',
    required: 12,
    optimal: 14,
    wrapper: false,
    state: 0,
    showPassword: false,
  }),

  emits: ['update:modelValue'],

  watch: {
    password: {
      handler(pwNew, pwOld) {
        if (pwOld === pwNew) return
        this.$emit('update:modelValue', pwNew)
        this.state = (pwNew.length / this.optimal) * 100
        return pwNew
      },

      immediate: true,
    },

    modelValue(value) {
      this.password = value
    },
  },

  beforeMount() {
    this.password = this.modelValue
  },

  created() {
    this.secondPassword = this.modelValue
  },
}
</script>

<style scoped lang="scss">
.passwordInputGroup {
  position: relative;
}

.validation-star {
  font-size: pxtorem(9);
  position: relative;
  bottom: 1px;
}
</style>
